module.exports = __webpack_public_path__ + "static/img/miandan.4710fe81.png";